module.exports = __webpack_public_path__ + "static/media/manufacturing-microone-01 1.8f4d0aea.png";